
import { createContext } from 'react'
import { UserInfo } from '../interfaces/user-interface'

export const AuthContext = createContext<{
    user: UserInfo | undefined,
    setUser: React.Dispatch<React.SetStateAction<UserInfo | undefined>> | null;
    isLoading: boolean;
}>({
    user: undefined,
    setUser: null,
    isLoading: true,
});
